import {
  type EdgeId,
  type NodeId,
  isNonNullable,
  isPathLookupNodeData,
} from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';

export const hasOneIncomingPacket = (
  incomingEdges: EdgeId[],
  nodeId: NodeId,
  graph: GraphData,
): boolean => {
  // Fixed noUncheckedIndexedAccess NIM-19408
  const nodeData = graph.nodes[nodeId]!;
  const generatedPacketCount =
    isPathLookupNodeData(nodeData) && isNonNullable(nodeData.generatedPackets)
      ? Object.keys(nodeData.generatedPackets).length
      : 0;

  return incomingEdges.length + generatedPacketCount === 1;
};
